import { ReactNode } from "react";
import { useCookieConsent } from "../cookieContext";
import { CookieBlocker } from "../../cookieBlocker/cookieBlocker";
import { ConsentState } from "../cookieTypes";

interface WithCookieConsentProps {
    category: keyof Omit<ConsentState, "necessary">;
    children: ReactNode;
    title?: string;
    description?: string;
    onConsentChange?: (hasConsent: boolean) => void;
}

export const WithCookieConsent: React.FC<WithCookieConsentProps> = ({
    category,
    children,
    title,
    description,
    onConsentChange,
}) => {
    const { consent, hasConsent, setConsent } = useCookieConsent();

    const handleAcceptCategory = () => {
        if (!consent) return;

        const newConsent = {
            ...consent,
            [category]: true,
        };

        setConsent(newConsent);
        onConsentChange?.(true);
    };

    if (hasConsent(category)) {
        return <>{children}</>;
    }

    return (
        <CookieBlocker
            category={category}
            title={title}
            description={description}
            onAccept={handleAcceptCategory}
        />
    );
};
